<script>
import axios from "axios";
import FormAsignarUsuario from "../../../formulario/FormAsignarUsuario.vue";

import moment from "moment";
import Usuarios from "../../Componentes/Usuarios.vue";
import Cde from "@/components/Despachos/Componentes/cde/cde.vue";
import Documentos from "../../Componentes/Documentos.vue";
import Pagos from "../../Componentes/Pagos.vue";
import Contenedores from "../../Componentes/Contenedores.vue";
export default {
  components: {
    FormAsignarUsuario,
    Usuarios,
    Documentos,
    Pagos,
    Contenedores,
    Cde,
  },
  props: {
    despacho: Object,
    submit: Function,
    canManage: {
      type: Function,
      default: () => {
        return true;
      },
    },
    usuarios: Array,

    documentosTabla: Array,
    pagosTabla: Array,
    montos: Object,
    getComprobante: Function,

    eliminarDocumentos: Function,
    showDeleteDocumentos: Boolean,
    actualizarDocumentos: Function,
    confirmarDeleteDocumentos: Function,
    cerrarModal: Function,
    metodoThen: Function,
    metodoCatch: Function,
  },
  data() {
    return {
      despachoRoute: axios.defaults.baseURL + "api/admin/despachos/",
      despachoPadreRoute:
        axios.defaults.baseURL + "api/admin/despachos/perfil/",
      secciones: {
        general: false,
        carga: false,
        pagos: false,
        usuarios: false,
        documentos: true,
        cde: false,
      },
    };
  },
  methods: {
    //secciones
    cambiarSeccion(seccion) {
      Object.keys(this.secciones).forEach((key) => {
        if (key == seccion) this.secciones[key] = true;
        else this.secciones[key] = false;
      });
    },
    ver(item, button) {
      const routeData = this.$router.resolve({
        name: "PerfilDespacho",
        params: { despachoId: item },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<template>
  <b-tabs content-class="mt-3" class="tabs-secciones">
    <b-tab title="Informacion General" @click="cambiarSeccion('general')">
      <template #title>
        <div class="title-tab">
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/general.svg"
            title="My Image"
          />
          <p class="titulo text-center">Información General</p>
        </div>
      </template>
      <div
        v-if="secciones.general"
        class="grid gris-cola-1 md:grid-cols-2 gap-8 p-[2%]"
      >
        <div
          v-if="despacho.tipo_despacho == 'exportacion'"
          class="md:col-span-2 grid gris-cola-1 md:grid-cols-2 gap-8"
        >
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">N° Despacho</div>
            <div class="text-right font-bold">
              {{ despacho.codigo ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Despacho Padre</div>
            <div class="text-right font-bold">
              <a
                target="_blank"
                :href="despachoPadre + despacho.padre_id"
                v-if="despacho.padre_id"
                >{{ despachoPadre }} {{ despacho.padre_id }}</a
              >
              <div v-else>-</div>
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Agente</div>
            <div class="text-right font-bold">
              {{ despacho.agente?.nombre ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Cliente</div>
            <div class="text-right font-bold">
              {{ despacho?.cliente?.nombre ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Referencia Cliente</div>
            <div class="text-right font-bold">
              {{ despacho.ref_cliente ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Fecha efectiva de arribo</div>
            <div class="text-right font-bold">
              {{
                despacho.fecha_efectiva_arribo
                  ? moment(despacho.fecha_efectiva_arribo).format("DD-MM-YYYY")
                  : "-"
              }}
            </div>
          </div>
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Fecha Creacion</div>
            <div class="text-right font-bold">
              {{ moment(despacho.fecha_inicio).format("DD-MM-YYYY") }}
            </div>
          </div>
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Estado Despacho</div>
            <div class="text-right font-bold">
              {{ despacho.estado_despacho?.toUpperCase() }}
            </div>
          </div>
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Tipo de Despacho</div>
            <div class="text-right font-bold uppercase">
              {{ despacho.tipo_despacho }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Estado Retiro</div>
            <div class="text-right font-bold">
              {{ despacho.estado_retiro ?? "-" }}
            </div>
          </div>
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Aforo Dus Legalizado</div>
            <div class="text-right font-bold">
              {{ despacho.tipo.aforo_dus_legalizado ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Aforo Zona Primaria</div>
            <div class="text-right font-bold">
              {{ despacho.tipo.aforo_zona_primaria ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Estado Dus Legalizado</div>
            <div class="text-right font-bold">
              {{ despacho.tipo.dus_legalizado ?? "-" }}
            </div>
          </div>
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Estado Dus Primer Envio</div>
            <div class="text-right font-bold">
              {{ despacho?.tipo?.dus_primer_envio ?? "-" }}
            </div>
          </div>
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Número Reserva</div>
            <div class="text-right font-bold">
              {{ despacho?.tipo?.numero_reserva ?? "-" }}
            </div>
          </div>
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Aduana</div>
            <div class="text-right font-bold">
              {{ despacho.tipo?.aduana?.nombre ?? "-" }}
            </div>
          </div>
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Puerto / Aereo</div>
            <div class="text-right font-bold">
              {{ despacho.tipo?.extraportuario?.nombre ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Estado Presentacion Matriz</div>
            <div class="text-right font-bold">
              {{ despacho.tipo.estado_presentacion_matriz ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Requiere Vistos Buenos (CDA)</div>
            <div class="text-right font-bold">
              {{ despacho.requiere_vistos_buenos ? "Si" : "No" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Fecha Aforo Dus Legalizado</div>
            <div class="text-right font-bold">
              {{
                despacho.tipo.fecha_aforo_dus_legalizado
                  ? moment(despacho.tipo.fecha_aforo_dus_legalizado).format(
                      "DD-MM-YYYY"
                    )
                  : "-"
              }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Fecha Aforo Zona Primaria</div>
            <div class="text-right font-bold">
              {{
                despacho.tipo.fecha_aforo_zona_primaria
                  ? moment(despacho.tipo.fecha_aforo_zona_primaria).format(
                      "DD-MM-YYYY"
                    )
                  : "-"
              }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Fecha Ingreso Zona Primaria</div>
            <div class="text-right font-bold">
              {{
                despacho.tipo.fecha_ingreso_zona_primaria
                  ? moment(despacho.tipo.fecha_ingreso_zona_primaria).format(
                      "DD-MM-YYYY"
                    )
                  : "-"
              }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Fecha Salida Programada</div>
            <div class="text-right font-bold">
              {{
                despacho.tipo.fecha_salida_programada
                  ? moment(despacho.tipo.fecha_salida_programada).format(
                      "DD-MM-YYYY"
                    )
                  : "-"
              }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Medio de Transporte</div>
            <div class="text-right font-bold">
              {{ despacho.tipo.nombre_transporte ?? "-" }}
            </div>
          </div>
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Nombre de Nave</div>
            <div class="text-right font-bold">
              {{ despacho?.tipo?.nombre_nave ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
            v-if="despacho?.tipo?.nombre_transporte == 'MARÍTIMO'"
            hidden
          >
            <div class="text-left">Lugar Bl</div>
            <div class="text-right font-bold">
              {{ despacho.lugar_bl ?? "-" }}
            </div>
          </div>
        </div>

        <!-- ===================== IMPORTACIÓN ========================= -->

        <div
          v-if="despacho.tipo_despacho == 'importacion'"
          class="md:col-span-2 grid gris-cola-1 md:grid-cols-2 gap-8"
        >
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">N° Despacho</div>
            <div class="text-right font-bold">
              {{ despacho.codigo }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Despacho Padre</div>
            <div class="text-right font-bold">
              <a
                href=""
                @click="ver(despacho.padre_id, $event.target)"
                v-if="despacho.padre_id"
                >{{ despacho.padre_id }}</a
              >
              <div v-else>-</div>
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Cliente</div>
            <div class="text-right font-bold">
              {{ despacho?.cliente?.nombre }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Referencia Cliente</div>
            <div class="text-right font-bold">
              {{ despacho.ref_cliente }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Agente</div>
            <div class="text-right font-bold">
              {{ despacho.agente?.nombre ?? "-" }}
            </div>
          </div>
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Fecha Creacion</div>
            <div class="text-right font-bold">
              {{
                despacho.fecha_inicio
                  ? moment(despacho.fecha_inicio).format("DD-MM-YYYY")
                  : "-"
              }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Fecha efectiva de arribo</div>
            <div class="text-right font-bold">
              {{
                despacho.fecha_efectiva_arribo
                  ? moment(despacho.fecha_efectiva_arribo).format("DD-MM-YYYY")
                  : "-"
              }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Estado Despacho</div>
            <div class="text-right font-bold">
              {{ despacho.estado_despacho?.toUpperCase() }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Gestor de Despacho</div>
            <div class="text-right font-bold">
              {{
                despacho?.gestores?.length > 0 ? despacho.gestores[0].name : "-"
              }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Tipo de Despacho</div>
            <div class="text-right font-bold uppercase">
              {{ despacho.tipo_despacho }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Estado Retiro</div>
            <div class="text-right font-bold">
              {{ despacho.estado_retiro ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Fecha Eta</div>
            <div class="text-right font-bold">
              {{
                despacho.tipo.fecha_eta
                  ? moment(despacho.tipo.fecha_eta).format("DD-MM-YYYY")
                  : "-"
              }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Aduana</div>
            <div class="text-right font-bold">
              {{ despacho.tipo?.aduana?.nombre ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Extraportuario</div>
            <div class="text-right font-bold">
              {{ despacho.tipo?.extraportuario?.nombre ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Manifiesto</div>
            <div class="text-right font-bold">
              {{ despacho.tipo?.manifiesto?.nombre ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Tipo de inspección de Aforo</div>
            <div class="text-right font-bold">
              <div>{{ despacho?.tipo_inspeccion_aforo?.nombre ?? "-" }}</div>
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Requiere Vistos Buenos (CDA)</div>
            <div class="text-right font-bold">
              {{ despacho.requiere_vistos_buenos ? "Si" : "No" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Medio de Transporte</div>
            <div class="text-right font-bold">
              {{ despacho.tipo.nombre_transporte ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Nombre de Nave</div>
            <div class="text-right font-bold">
              {{ despacho.tipo?.nombre_nave ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
            v-if="despacho.tipo.nombre_transporte == 'MARÍTIMO'"
            hidden
          >
            <div class="text-left">Lugar Bl</div>
            <div class="text-right font-bold">
              {{ despacho.lugar_bl ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Numero Manifiesto</div>
            <div class="text-right font-bold">
              {{ despacho?.tipo?.numero_manifiesto ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left">Agente Cargas</div>
            <div class="text-right font-bold">
              {{ despacho?.tipo?.agente_cargas?.nombre ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left dato">Compañia Naviera</div>
            <div class="text-right font-bold">
              {{ despacho.tipo?.compania_naviera?.nombre ?? "-" }}
            </div>
          </div>

          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left dato">Tipo Condición</div>
            <div class="text-right font-bold">
              {{ despacho.tipo?.tipo_condicion ?? "-" }}
            </div>
          </div>
          <div
            class="flex flex-row items-center gap-4 justify-between border-b border-primary/20"
          >
            <div class="text-left dato">Datos Transporte</div>
            <div class="text-right font-bold">
              <div v-if="despacho.transporte">
                {{ despacho.transporte }} /
                {{ despacho.correo_transporte }}
              </div>
              <div v-else>-</div>
            </div>
          </div>
        </div>
      </div>
    </b-tab>
    <b-tab title="Asignar Usuarios" @click="cambiarSeccion('usuarios')">
      <template #title>
        <div class="title-tab">
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/usuarios.svg"
            title="My Image"
          />
          <p class="titulo text-center">Asignar Usuarios</p>
        </div>
      </template>
      <usuarios
        v-if="secciones.usuarios"
        :agregarUsuario="false"
        :usuarios="usuarios"
      >
      </usuarios>
    </b-tab>
    <b-tab title="" active @click="cambiarSeccion('documentos')">
      <template #title>
        <div class="title-tab">
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/documento.svg"
            title="My Image"
          />
          <p class="titulo text-center">Documentación</p>
        </div>
      </template>
      <documentos
        v-if="documentosTabla && secciones.documentos"
        :agregarDocumento="false"
        :documentosTabla="documentosTabla"
        :eliminarDocumentos="eliminarDocumentos"
        :showDeleteDocumentos="showDeleteDocumentos"
        :actualizarDocumentos="actualizarDocumentos"
        :confirmarDeleteDocumentos="confirmarDeleteDocumentos"
        :cerrarModal="cerrarModal"
        :metodoThen="metodoThen"
        :metodoCatch="metodoCatch"
        export-documents
        :general="true"
      >
      </documentos>
    </b-tab>
    <b-tab title="CDE" @click="cambiarSeccion('cde')">
      <template #title>
        <div class="title-tab">
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/documento.svg"
            title="My Image"
          />
          <p class="titulo text-center">CDE</p>
        </div>
      </template>
      <cde v-if="secciones.cde"> </cde>
    </b-tab>
    <b-tab title="Pagos" @click="cambiarSeccion('pagos')">
      <template #title>
        <div class="title-tab">
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/dollar.svg"
            title="My Image"
          />
          <p class="titulo text-center">Pagos</p>
        </div>
      </template>
      <pagos
        v-if="pagosTabla && secciones.pagos"
        :agregarPago="false"
        :despacho="despacho"
        :getComprobante="getComprobante"
        :pagosTabla="pagosTabla"
        :canManage="canManage"
      >
      </pagos>
    </b-tab>
    <b-tab title="Detalle Carga" @click="cambiarSeccion('carga')">
      <template #title>
        <div class="title-tab">
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/containers.svg"
            title="My Image"
          />
          <p class="titulo text-center">Detalle Carga</p>
        </div>
      </template>
      <contenedores
        v-if="secciones.carga"
        :permiteAgregarContenedor="false"
        :despacho="despacho"
        :canManage="canManage"
      >
      </contenedores>
    </b-tab>
  </b-tabs>
</template>
